const LOCAL_HOST = "localhost:3000";
const PRODUCTION_HOST =
  process.env.REACT_APP_API_HOST || "fintech-tx.herokuapp.com/";

export const domain = PRODUCTION_HOST
  ? `https://${PRODUCTION_HOST}`
  : `http://${LOCAL_HOST}`;

export const MainUrls = {
  login: `${domain}/users/sign_in`,
  signup: `${domain}/users`,
  EMAIL_VERIFICATION: `${domain}/password/email_varified`,
  FORGOT_PASSWORD: `${domain}/password/forgot`,
  RESET_PASSWORD: `${domain}/password/reset`,
  VERIFY_USER: `${domain}/users/verify_user`,
};

export const ApiUrls = {
  createWallet: `${domain}/api/v1/wallet/create`,
  GET_DASHBOARD_DATA: `${domain}/api/v1/dashboard`,
  GET_ALL_TRANSACTIONS_DATA: `${domain}/api/v1/transactions/index`,
  FUND_WALLET: `${domain}/api/v1/wallet/add_funds`,
  GET_BANK_DATA: `${domain}/api/v1/banks/index`,                             
  SideList_DATA: `${domain}/api/v1/payment_gateways/billing_payment`,    
  UPDATE_USER: `${domain}/api/v1/users/update`,
  UPDATE_PASSWORD: `${domain}/api/v1/users/update_password`,
  VERIFY_OTP_FOR_EMAIL_UPDATE: `${domain}/api/v1/users/verify_otp`,
  GET_FREEZE_WALLETS: `${domain}/api/v1/wallet/freeze_wallets`,
  FREEZE_WALLET: `${domain}/api/v1/wallet/update`,
};

export const AdminUrls = {
  GET_TRANSACTIONS_LISTING: `${domain}/api/admin/transactions/index`,
  CREATE_USER: `${domain}/api/admin/users/create`,
  UPDATE_USER: `${domain}/api/admin/users/update`,
  UPDATE_WALLET: `${domain}/api/admin/wallets/update`,
  GET_USERS_LISTING: `${domain}/api/admin/users/index`,
  USER_STATUS: `${domain}/api/admin/users/update`,
  ADD_PAYMENT_GATEWAY: `${domain}/api/admin/payment_gateways/create`,
  UPDATE_PAYMENT_GATEWAY: `${domain}/api/admin/payment_gateways/update`,
  GET_PAYMENT_GATEWAYS_LISTING: `${domain}/api/admin/payment_gateways/index`,
  ADD_SERVICE_PROVIDER: `${domain}/api/admin/service_providers/create`,
  UPDATE_SERVICE_PROVIDER: `${domain}/api/admin/service_providers/update`,
  GET_SERVICE_PROVIDERS_LISTING: `${domain}/api/admin/service_providers/index`,
};
